import {
  View,
  Text,
  StyleSheet,
  TextInput,
  TouchableOpacity,
  ScrollView,
  Modal,
} from "react-native";
import React, { useState, useEffect } from "react";
import { observer, Observer } from "mobx-react";
import GlobalStyles from "../../../Resources/Styles";
import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";
import { Octicons } from "@expo/vector-icons";
import { AntDesign } from "@expo/vector-icons";
import { useScreenDimensions, useDevice } from "../../_layout";
import { Menu, MenuItem } from "react-native-material-menu";
import { MaterialIcons } from "@expo/vector-icons";

import Clipboard from "@react-native-clipboard/clipboard";

import db from "../../Firestore/FirestoreConfig";
import {
  collection,
  query,
  where,
  getDocs,
  getDoc,
  setDoc,
  doc,
  updateDoc,
  deleteField,
  deleteDoc,
} from "firebase/firestore";
import { useTranslation } from "react-i18next";

import { format } from "date-fns";

import Feather from "@expo/vector-icons/Feather";
import Ionicons from "@expo/vector-icons/Ionicons";
import CustomAlert from "../../Components/CustomAlert";
import LogoImage from "../../Components/LogoImage";
import { getHeaderLogoMaxWidth } from "../../Components/logoImageHeaderSizing";
import SyncStatusIndicator from "../../Components/SyncStatusIndicator";
import { ActivityIndicator } from "react-native-web";
import CustomActivityIndicator from "../../Components/CustomActivityIndicator";
import AddApplicationForm from "./AddApplicationForm";
import BackButton from "../../Components/BackButton";
import { useToast } from "../../contexts/ToastContext";

const CoachApplications = ({ coach }) => {
  const { t } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const headerLogoMaxWidth = getHeaderLogoMaxWidth(screenSize);
  const { isMobile } = useDevice();
  const { showToast } = useToast();
  const [isLoadingView, setIsLoadingView] = useState(true);

  useEffect(() => {
    const fetchApplications = async () => {
      await coach.syncStatusManager.safeOperation("fetchApplicationForm", () =>
        coach.fetchApplicationFormFromCloud()
      );
      await coach.syncStatusManager.safeOperation("fetchApplications", () =>
        coach.fetchApplicationsFromCloud()
      );

      setIsLoadingView(false);
    };
    coach.setProperty("coachDirectoryAux", coach.coachDirectory);
    if (coach.applicationForm === null) {
      fetchApplications();
    } else {
      setIsLoadingView(false);
    }
  }, []);

  const [showingDirectoryTaken, setShowingDirectoryTaken] = useState(false);

  const [showingDeleteApplication, setShowingDeleteApplication] =
    useState(false);
  const deleteApplicationTitle = "deleteApplicationAlertTitle-string";
  const deleteApplicationText = "deleteApplicationAlertText-string";

  const CoachDirectoryInput = observer(() => {
    const [showingDeleteCoachApplication, setShowingDeleteCoachApplication] =
      useState(false);
    const deleteCoachApplicationTitle =
      "deleteCoachApplicationAlertTitle-string";
    const deleteCoachApplicationText = "deleteCoachApplicationAlertText-string";

    const [isLoading, setIsLoading] = useState(false);
    const specialChars = /[ @#!$%^&*()=+?:;~\\|'"<>\[\]{}\/]/;

    const handleCopyToClipboard = () => {
      const url = `www.app.efortcoach.com/${coach.coachDirectory}`;
      Clipboard.setString(url);
      console.log("URL copied to clipboard:", url);
    };

    const Save = async () => {
      if (!coach.isOffline) {
        if (specialChars.test(coach.coachDirectoryAux)) {
          console.log(
            "Invalid directory name. It contains special characters."
          );
          return;
        }

        setIsLoading(true);

        try {
          // Query to check if any document has the same directory name
          const directoriesRef = collection(db, "coach_directories");
          const q = query(
            directoriesRef,
            where("directory", "==", coach.coachDirectoryAux.toLowerCase())
          );
          const querySnapshot = await getDocs(q);

          if (!querySnapshot.empty) {
            // A document with the same directory already exists
            console.log("This directory name is already taken.");
            setIsLoading(false);
            setShowingDirectoryTaken(true);
          } else {
            // No document with this directory name exists, so create/update coach's document
            const coachDocRef = doc(directoriesRef, coach.id);

            await setDoc(
              coachDocRef,
              {
                directory: coach.coachDirectoryAux.toLowerCase(),
                coach_id: coach.id,
              },
              { merge: true }
            );

            const coachingFormDocRef = doc(
              db,
              "coaching_application_forms",
              coach.id
            );

            const docSnapshot = await getDoc(coachingFormDocRef);
            if (docSnapshot.exists()) {
              // Update only if the document exists
              await updateDoc(coachingFormDocRef, {
                directory: coach.coachDirectoryAux.toLowerCase(),
              });
            } else {
              // Document does not exist, so we do nothing and log
              console.log(
                "Coaching form document does not exist, skipping update."
              );
            }
            coach.setProperty(
              "coachDirectory",
              coach.coachDirectoryAux.toLowerCase()
            );
            console.log("Directory created or updated successfully.");
            setIsLoading(false);
            setShowingDirectoryTaken(false);
          }
        } catch (error) {
          console.error("Error checking or saving directory: ", error);
        }
      }
    };

    const [isHovered, setIsHovered] = useState(false);

    const SaveButton = observer(() => {
      const [isHovered, setIsHovered] = useState(false);

      return (
        <TouchableOpacity
          onPress={Save}
          style={{
            opacity: coach.isOffline ? 0.5 : isHovered && !isLoading ? 0.5 : 1,
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {isLoading ? (
            <CustomActivityIndicator large={false} />
          ) : (
            <Text
              style={{
                color: Colors.bubbleColor,
              }}
            >
              {t("save-string")}
            </Text>
          )}
        </TouchableOpacity>
      );
    });

    const deleteCoachApplication = async () => {
      if (!coach.isOffline) {
        setIsLoading(true);

        try {
          const directoriesRef = collection(db, "coach_directories");
          const coachDocRef = doc(directoriesRef, coach.id);

          // Check if the document exists
          const docSnapshot = await getDoc(coachDocRef);
          if (!docSnapshot.exists()) {
            console.log("Directory does not exist, nothing to delete.");
            setIsLoading(false);
            return;
          }

          // Delete the document
          await deleteDoc(coachDocRef);
          console.log("Directory deleted successfully.");

          // Update the coaching form document to remove the directory field

          const coachingFormDocRef = doc(
            db,
            "coaching_application_forms",
            coach.id
          );
          const coachingFormSnapshot = await getDoc(coachingFormDocRef);

          if (coachingFormSnapshot.exists()) {
            await deleteDoc(coachingFormDocRef);
            console.log("Coaching form document deleted.");
          }
          coach.initEditApplicationFormView();
          coach.setProperty("coachDirectory", "");
          coach.setProperty("coachDirectoryAux", "");

          setIsLoading(false);
        } catch (error) {
          console.error("Error deleting directory: ", error);
          setIsLoading(false);
        }
      }
    };
    const DeleteButton = observer(() => {
      const [isHovered, setIsHovered] = useState(false);
      const [isLoading, setIsLoading] = useState(false);

      return (
        <TouchableOpacity
          onPress={() => setShowingDeleteCoachApplication(true)}
          style={{
            opacity: coach.isOffline ? 0.5 : isHovered && !isLoading ? 0.5 : 1,
            marginLeft: 8,
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {!isLoading ? (
            <>
              {screenSize != "small" ? (
                <Text
                  style={{
                    color: isHovered ? Colors.redColor : Colors.grayColor,
                  }}
                >
                  {t("deleteForm-string")}
                </Text>
              ) : (
                <Ionicons
                  name={isHovered ? "trash" : "trash-outline"}
                  size={20}
                  color={"red"}
                  style={{}}
                />
              )}
            </>
          ) : (
            <CustomActivityIndicator large={false} />
          )}
        </TouchableOpacity>
      );
    });

    return (
      <>
        <View
          style={{
            backgroundColor: Colors.whiteColor,
            padding: screenSize === "small" ? 12 : 15,
            borderRadius: 14,
            borderWidth: 0.1,
            borderColor: isHovered ? "rgba(0, 0, 0, 0.5)" : Colors.borderColor,

            flex: 1,
            alignItems: "flex-start",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              flexDirection: "row",
              width: "100%",
              alignItems: "center",
            }}
          >
            <TouchableOpacity onPress={handleCopyToClipboard}>
              <Feather
                name="copy"
                size={20}
                color={Colors.bubbleColor}
                style={{
                  marginRight: 10,
                  opacity: coach.coachDirectory === "" ? 0.5 : 1,
                }}
              />
            </TouchableOpacity>

            <Text
              style={{
                marginRight: 1,
                letterSpacing: 0,
                fontSize: screenSize === "small" ? 12 : 14,
              }}
            >
              www.app.efortcoach.com/
            </Text>
            <TextInput
              value={coach.coachDirectoryAux}
              onChangeText={(text) =>
                coach.setProperty("coachDirectoryAux", text)
              }
              style={{
                color: "black",
                outline: "none",
                fontSize: screenSize === "small" ? 12 : 14,
                width: "100%",
              }}
              placeholder={t("yourBrand-string")}
              placeholderTextColor={Colors.grayColor}
              maxLength={40}
              editable={!coach.isOffline}
            />
            <View style={{ flex: 1 }} />
            {screenSize !== "small" &&
            coach.coachDirectoryAux.toLowerCase() !==
              coach.coachDirectory.toLowerCase() &&
            coach.coachDirectoryAux !== "" &&
            !specialChars.test(coach.coachDirectoryAux) ? (
              <SaveButton />
            ) : (
              coach.coachDirectoryAux !== "" &&
              !specialChars.test(coach.coachDirectoryAux) && <DeleteButton />
            )}
          </View>

          {showingDirectoryTaken && (
            <Text
              style={{ color: Colors.redColor, fontSize: 12, marginTop: 5 }}
            >
              {t("directoryTaken-string")}
            </Text>
          )}
        </View>
        {screenSize === "small" &&
          coach.coachDirectoryAux.toLowerCase() !==
            coach.coachDirectory.toLowerCase() &&
          coach.coachDirectoryAux !== "" &&
          !specialChars.test(coach.coachDirectoryAux) && (
            <TouchableOpacity
              onPress={Save}
              style={{ opacity: coach.isOffline ? 0.5 : 1 }}
            >
              {isLoading ? (
                <CustomActivityIndicator large={false} white={false} />
              ) : (
                <Text
                  style={{
                    color: Colors.bubbleColor,
                    alignSelf: "center",
                    marginTop: 10,
                  }}
                >
                  {t("save-string")}
                </Text>
              )}
            </TouchableOpacity>
          )}
        {showingDeleteCoachApplication && (
          <CustomAlert
            isVisible={showingDeleteCoachApplication}
            onClose={() => setShowingDeleteCoachApplication(false)}
            title={deleteCoachApplicationTitle}
            text={deleteCoachApplicationText}
            action={deleteCoachApplication}
            specialCTA="delete-string"
          />
        )}
      </>
    );
  });

  const SeparatorLine = () => {
    return (
      <View
        style={{
          flexDirection: "row",
          width: "100%",
          alignItems: "center",
          marginTop: screenSize === "small" ? 8 : 12,
        }}
      >
        <View
          style={{ height: 1, flex: 1, backgroundColor: Colors.borderColor }}
        />
        <Text style={{ paddingHorizontal: 20, color: Colors.grayColor }}>
          {t("applications-string")}
        </Text>
        <View
          style={{ height: 1, flex: 1, backgroundColor: Colors.borderColor }}
        />
      </View>
    );
  };

  const EditFormButton = observer(() => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <TouchableOpacity
        onPress={() => {
          if (coach.coachDirectory !== "" && !coach.isOffline) {
            coach.initEditApplicationFormView();
            coach.setProperty("showingEditForm", true);
          }
        }}
        style={{
          backgroundColor: Colors.bubbleColor,
          padding: 12,
          borderRadius: 14,
          marginLeft: screenSize !== "small" && 20,
          marginTop: screenSize === "small" && 20,
          alignItems: "center",
          justifyContent: "center",
          opacity:
            coach.coachDirectory === "" || coach.isOffline
              ? 0.5
              : isHovered
              ? 0.7
              : 1,
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Text
          style={{
            color: "white",
            textAlign: "center",
            fontSize: 14,
            fontWeight: "500",
          }}
        >
          {t("editForm-string")}
        </Text>
      </TouchableOpacity>
    );
  });

  const EmptyView = observer(() => {
    const StepRow = ({ number, text }) => {
      return (
        <View
          style={{
            flexDirection: "row",
            marginTop: 24,
            alignItems: "center",
            width:
              screenSize === "small"
                ? "60%"
                : screenSize === "medium"
                ? "50%"
                : "30%",
          }}
        >
          <View
            style={{
              alignItems: "center",
              marginRight: 24,
              justifyContent: "center",
            }}
          >
            <View
              style={{
                width: 24,
                height: 24,
                borderRadius: 50,
                alignItems: "center",
                justifyContent: "center",
                alignSelf: "center",
                position: "absolute",
                backgroundColor: Colors.bubbleColor,
              }}
            >
              <Text
                style={{
                  color: Colors.whiteColor,
                  textAlign: "center",
                  alignSelf: "center",
                  fontWeight: "500",
                }}
              >
                {number}
              </Text>
            </View>
          </View>
          <Text>{text}</Text>
        </View>
      );
    };
    return (
      <View
        style={{
          width: "100%",
          alignItems: "center",
          flex: 1,
          justifyContent: "center",
          marginTop: 120,
          padding: 16,
        }}
      >
        <View
          style={{
            alignItems: "center",
            marginBottom: 20,
            justifyContent: "center",
          }}
        >
          <View
            style={{
              width: 64,
              height: 64,
              borderRadius: 32,
              backgroundColor: Colors.bubbleColor,
              opacity: 0.06,
              position: "absolute",
            }}
          />
          <View
            style={{
              width: 48,
              height: 48,
              borderRadius: 24,
              backgroundColor: Colors.bubbleColor,
              opacity: 0.08,
              justifyContent: "center",
              alignItems: "center",
              alignSelf: "center",
              position: "absolute",
            }}
          />
          <View
            style={{
              width: 48,
              height: 48,
              borderRadius: 24,
              alignItems: "center",
              justifyContent: "center",
              alignSelf: "center",
              position: "absolute",
            }}
          >
            <Ionicons
              name={
                coach.coachDirectory === "" ? "document-text" : "person-add"
              }
              size={24}
              color={Colors.bubbleColor}
            />
          </View>
        </View>

        {coach?.applicationForm &&
        coach.applicationForm?.sections?.length === 1 &&
        coach.applicationForm.sections[0].name === "" &&
        coach.applicationForm.sections[0].questions.length === 1 &&
        coach.applicationForm.sections[0].questions[0].question === "" ? ( //Mirar que el coach no hagi canviat res del formulari que se li fica per defecte
          <>
            <Text
              style={[
                screenSize === "small" ? Fonts.medium16 : Fonts.medium16,
                {
                  textAlign: "center",
                  color: Colors.blackColor,
                  marginTop: 32,
                },
              ]}
            >
              {t("registrationForm-string")}
            </Text>
            <Text
              style={[
                screenSize === "small" ? Fonts.regular14 : Fonts.regular14,
                {
                  textAlign: "center",
                  color: Colors.grayColor,
                  marginTop: 8,
                },
              ]}
            >
              {t("followTheseSteps-string")}
            </Text>
            <StepRow number={"1"} text={t("ApplicationStep1-string")} />
            <StepRow number={"2"} text={t("ApplicationStep2-string")} />
            <StepRow number={"3"} text={t("ApplicationStep3-string")} />
          </>
        ) : (
          <>
            <Text
              style={[
                screenSize === "small" ? Fonts.medium16 : Fonts.medium16,
                {
                  textAlign: "center",
                  color: Colors.blackColor,
                  marginTop: 32,
                },
              ]}
            >
              {t("noNewApplications-string")}
            </Text>
            <Text
              style={[
                screenSize === "small" ? Fonts.regular14 : Fonts.regular14,
                {
                  textAlign: "center",
                  color: Colors.grayColor,
                  marginTop: 8,
                },
              ]}
            >
              {t("whenNewApplication-string")}
            </Text>
          </>
        )}
      </View>
    );
  });

  const ApplicationRow = observer(
    ({ application, onSelectApplication, isFullWidth = false }) => {
      const [isHovered, setIsHovered] = useState(false);

      return (
        <View
          style={{
            width: isFullWidth
              ? "100%"
              : `calc((100% - ${screenSize === "small" ? 8 : 24}px) / ${
                  screenSize === "small" ? 2 : 3
                })`,
          }}
        >
          <TouchableOpacity
            onPress={() => onSelectApplication(application)}
            style={[
              GlobalStyles.touchableRow,
              {
                shadowColor: Colors.bubbleColor,
                borderWidth: 0.1,
                borderColor: application.isSelected
                  ? "black"
                  : isHovered
                  ? "rgba(0, 0, 0, 0.5)"
                  : Colors.borderColor,
              },
            ]}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <View
              style={{
                alignItems: "flex-start",
                justifyContent: "space-between",
                flex: 1,
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  marginBottom: 8,
                }}
              >
                <Text
                  numberOfLines={2}
                  style={[Fonts.medium14, { flexShrink: 1 }]}
                >
                  {application.clientName} {application.clientSurname}
                </Text>
                {!application.seenByCoach && (
                  <View
                    style={{
                      width: 8,
                      height: 8,
                      borderRadius: 4,
                      backgroundColor: Colors.bubbleColor,
                      marginLeft: 6,
                    }}
                  />
                )}
              </View>
              <View
                style={[
                  GlobalStyles.HStack,
                  { width: "100%", flexWrap: "wrap" },
                ]}
              >
                <View style={GlobalStyles.HStack}>
                  <Ionicons
                    name="calendar"
                    size={12}
                    color={Colors.bubbleColor}
                    style={GlobalStyles.rowIcon}
                  />
                  <Text
                    style={{
                      ...GlobalStyles.rowSubText,
                      fontSize: screenSize !== "large" ? 11 : 12,
                    }}
                    numberOfLines={1}
                  >
                    {application.date && format(application.date, "dd/MM/yy")}
                  </Text>
                </View>
              </View>
            </View>
          </TouchableOpacity>
        </View>
      );
    }
  );

  const ApplicationsGridView = () => {
    return (
      <View
        style={{
          flexDirection: "row",
          justifyContent: "flex-start",
          flexWrap: "wrap",
          marginTop: screenSize === "small" ? 8 : 12,
          width: "100%",
          gap: screenSize === "small" ? 8 : 12,
        }}
      >
        {coach.sortedApplications.map((application) => {
          return (
            <ApplicationRow
              application={application}
              key={application.id}
              onSelectApplication={(app) => coach.openApplication(app)}
            />
          );
        })}
      </View>
    );
  };

  const SideView = () => {
    const [isHovered, setIsHovered] = useState(false);

    return (
      <View
        style={{
          width: `${100 / 3}%`,
          paddingRight: screenSize === "small" ? 8 : 12,
        }}
      >
        <View style={{ marginBottom: 12 }}>
          <BackButton
            action={() =>
              coach.selectedApplication.setProperty("isSelected", false)
            }
            backString={t("back-string")}
          />
        </View>

        <View style={{ gap: 8 }}>
          {coach.sortedApplications.map((application) => {
            return (
              <ApplicationRow
                application={application}
                key={application.id}
                onSelectApplication={(app) => coach.openApplication(app)}
                isFullWidth
              />
            );
          })}
        </View>
      </View>
    );
  };

  const ApplicationDescriptionView = ({ application }) => {
    useEffect(() => {
      if (application && application.seenByCoach === false) {
        coach.markApplicationSeen(application);
      }
    }, [application?.id]);

    const SectionBlock = observer(({ section, idx }) => {
      const QuestionRow = observer(({ question, index }) => {
        return (
          question && (
            <View
              style={{
                width: "100%",
                borderLeftWidth: 5,
                borderLeftColor: Colors.bubbleColor,
                borderRadius: 5,
                paddingLeft: 4,
                marginTop: index !== 0 ? 20 : 0,
              }}
            >
              <View
                style={{
                  width: "100%",
                }}
              >
                <Text
                  style={{
                    color: Colors.grayColor,
                    fontSize: screenSize === "small" ? 12 : 14,
                    paddingLeft: 4,
                    marginBottom: 5,
                  }}
                >
                  {question.question}
                </Text>
                <Text
                  style={{
                    paddingLeft: screenSize === "small" ? 10 : 12,
                    fontSize: screenSize === "small" ? 14 : 16,
                  }}
                >
                  {question.answer}
                </Text>
              </View>
            </View>
          )
        );
      });
      return (
        <View>
          {idx !== 0 && <View style={styles.sectionDescSeparator} />}
          {section.name !== "" && (
            <Text
              style={{
                fontWeight: "600",
                fontSize: screenSize === "small" ? 12 : 14,
                marginBottom: 20,
              }}
            >
              {section.name}
            </Text>
          )}

          {section.questions &&
            section.questions.map((question, index) => (
              <QuestionRow question={question} key={index} index={index} />
            ))}
        </View>
      );
    });

    const Buttons = observer(() => {
      const [isLoading, setIsLoading] = useState(false);

      const Accept = async () => {
        if (!coach.isOffline) {
          setIsLoading(true); // Show loading indicator
          try {
            console.log("Send INVITATION");
            await coach.acceptApplication(application, showToast);
          } catch (error) {
            console.error("Error submitting the form: ", error);
          } finally {
            setIsLoading(false); // Hide loading indicator
          }
        }
      };

      const Button = ({ bool }) => {
        const [isHovered, setIsHovered] = useState(false);

        return bool ? (
          <TouchableOpacity
            onPress={Accept}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <View
              style={{
                backgroundColor: Colors.bubbleColor,
                borderRadius: 14,
                borderWidth: 1,
                justifyContent: "center",
                borderColor: Colors.bubbleColor,
                width: 80,
                height: 40,
                alignItems: "center",
                opacity: coach.isOffline ? 0.5 : isHovered ? 0.7 : 1,
              }}
            >
              {isLoading ? (
                <CustomActivityIndicator large={false} white={true} />
              ) : (
                <Text
                  style={{
                    textAlignVertical: "center",
                    textAlign: "center",
                    color: Colors.whiteColor,
                  }}
                >
                  {t("invite-string")}
                </Text>
              )}
            </View>
          </TouchableOpacity>
        ) : (
          <TouchableOpacity
            onPress={() => {
              if (!coach.isOffline) {
                setShowingDeleteApplication(true);
              }
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <View
              style={{
                width: 80,
                height: 40,
                justifyContent: "center",
                alignItems: "center",
                marginRight: 12,
                opacity: coach.isOffline ? 0.5 : 1,
              }}
            >
              <Text
                style={{
                  textAlignVertical: "center",
                  textAlign: "center",
                  color: Colors.redColor,
                  fontWeight: isHovered ? "500" : "normal",
                }}
              >
                {t("delete-string")}
              </Text>
            </View>
          </TouchableOpacity>
        );
      };

      return (
        <View
          style={{
            width: "100%",
            flexDirection: "row",
            justifyContent: "flex-end",
            marginTop: 20,
            alignSelf: "center",
          }}
        >
          <Button bool={false} />
          <Button bool={true} />
        </View>
      );
    });

    const [isHovered, setIsHovered] = useState(false);

    return (
      <View>
        {screenSize !== "large" && (
          <View style={{ marginBottom: 12 }}>
            <BackButton
              action={() =>
                coach.selectedApplication.setProperty("isSelected", false)
              }
              backString={t("back-string")}
            />
          </View>
        )}

        <View
          style={{
            flex: 1,
            backgroundColor: "white",
            borderRadius: 14,
            borderWidth: 0.1,
            borderColor: Colors.borderColor,
            paddingVertical: 16,
            paddingHorizontal: 12,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginBottom: 20,
            }}
          >
            <Text
              style={{
                fontSize: screenSize === "small" ? 12 : 14,
              }}
            >
              {t("nameDots-string")}
            </Text>
            <Text
              style={{
                fontWeight: "600",
                fontSize: screenSize === "small" ? 12 : 14,
              }}
              numberOfLines={1}
            >
              {application.clientName}
            </Text>
          </View>

          {application.clientSurname !== "" && (
            <View
              style={{ flexDirection: "row", marginTop: 0, marginBottom: 20 }}
            >
              <Text
                style={{
                  fontSize: screenSize === "small" ? 12 : 14,
                }}
              >
                {t("surnameDots-string")}
              </Text>
              <Text
                style={{
                  fontWeight: "600",
                  fontSize: screenSize === "small" ? 12 : 14,
                }}
                numberOfLines={1}
              >
                {application.clientSurname}
              </Text>
            </View>
          )}

          <View
            style={{
              flexDirection: "row",
              marginTop: 0,
              marginBottom: 20,
            }}
          >
            <Text
              style={{
                fontSize: screenSize === "small" ? 12 : 14,
              }}
            >
              {t("emailDots-string")}
            </Text>
            <Text
              style={{
                fontWeight: "600",
                fontSize: screenSize === "small" ? 12 : 14,
              }}
              numberOfLines={1}
            >
              {application.clientEmail}
            </Text>
          </View>

          <View style={styles.sectionDescSeparator} />
          {application.sections &&
            application.sections.map((section, index) => (
              <SectionBlock section={section} idx={index} key={index} />
            ))}
          <Buttons />

          <Observer>
            {() => (
              <>
                {application.emailIsWrong && (
                  <Text
                    style={[
                      Fonts.regular14,
                      { marginTop: 20, color: "red", alignSelf: "center" },
                    ]}
                  >
                    {t("errorSendingEmailText-string")}
                  </Text>
                )}
                {application.emailAlreadyInUse && (
                  <Text
                    style={[
                      Fonts.regular14,
                      { marginTop: 20, color: "red", alignSelf: "center" },
                    ]}
                  >
                    {t("emailAlreadyInUseText-string")}
                  </Text>
                )}
                {application.userAlreadyHasCoach && (
                  <Text
                    style={[
                      Fonts.regular14,
                      { marginTop: 20, color: "red", alignSelf: "center" },
                    ]}
                  >
                    {t("userAlreadyHasCoachText-string")}
                  </Text>
                )}
                {application.error && (
                  <Text
                    style={[
                      Fonts.regular14,
                      { marginTop: 20, color: "red", alignSelf: "center" },
                    ]}
                  >
                    {t("errorSendingEmailText-string")}
                  </Text>
                )}
              </>
            )}
          </Observer>

          {showingDeleteApplication && (
            <CustomAlert
              isVisible={showingDeleteApplication}
              onClose={() => setShowingDeleteApplication(false)}
              title={deleteApplicationTitle}
              text={deleteApplicationText}
              action={() => coach.deleteApplication(application)}
              specialCTA="delete-string"
            />
          )}
        </View>
      </View>
    );
  };
  return (
    <View style={[styles.container, { marginBottom: 20 }]}>
      <View>
        <View
          style={{
            marginBottom: 20,
            flexDirection: "row",
            // justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Text
            style={[
              Fonts.bold24,
              { marginRight: screenSize === "small" ? 8 : 12, fontWeight: "600" },
            ]}
          >
            {t("applications-string")}
          </Text>
          <SyncStatusIndicator
            syncStatusManager={coach.syncStatusManager}
            onPress={() => coach.startOrResetBatchTimer()}
          />
          <View style={{ flex: 1 }} />
          <LogoImage coach={coach} maxWidth={headerLogoMaxWidth} />
        </View>
        {isLoadingView ? (
          <CustomActivityIndicator marginTop={160} />
        ) : (
          <>
            <View
              style={{
                flexDirection: screenSize === "small" ? "column" : "row",
                // width: "100%",
              }}
            >
              <CoachDirectoryInput />
              <EditFormButton />
            </View>
            <SeparatorLine />

            <Observer>
              {() => (
                <>
                  {coach.sortedApplications.length === 0 ? (
                    <EmptyView />
                  ) : (
                    <ScrollView
                      contentContainerStyle={{
                        flexGrow: 1,
                        alignItems: "center",
                        backgroundColor: Colors.backgroundColor,
                      }}
                    >
                      {coach.selectedApplication ? (
                        <View
                          style={{
                            flexDirection: "row",
                            marginTop: screenSize === "small" ? 8 : 12,
                            width: "100%",
                          }}
                        >
                          {screenSize === "large" && <SideView />}
                          <View style={{ flexDirection: "column", flex: 1 }}>
                            <ApplicationDescriptionView
                              application={coach.selectedApplication}
                            />
                          </View>
                        </View>
                      ) : (
                        <ApplicationsGridView />
                      )}
                    </ScrollView>
                  )}
                  {coach.showingEditForm && coach.applicationForm && (
                    <AddApplicationForm
                      isVisible={coach.showingEditForm}
                      onClose={() =>
                        coach.setProperty("showingEditForm", false)
                      }
                      coach={coach}
                    />
                  )}
                </>
              )}
            </Observer>
          </>
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.backgroundColor,
  },
  sectionDescSeparator: {
    width: "95%",
    backgroundColor: Colors.borderColor,
    height: 1,
    alignSelf: "center",
    marginVertical: 15,
  },
});

export default CoachApplications;
